import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { PasswordSetupPayload } from "./dto";
import { recruiterClient } from "config/axios";
import PATHS from "config/paths";
import { QueryKeys } from "config/query-keys";

export const passwordSetup = (data: PasswordSetupPayload): Promise<{}> => {
  return recruiterClient.httpClient.post(PATHS.recruiter.changePassword.passwordSetup, data);
};

export const useRecruiterPasswordSetup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async (data, __, ___) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.RECRUITER] });
      notification.success({
        message: "Completed",
        description: "Password setup successfully completed.",
      });
    },

    mutationFn: passwordSetup,
  });
};
